<template>
  <div class="table-wrapper scrollable" :class="name + '-table'">
    <vs-table notSpacer hoverFlat pagination maxItems="20" :data="gridData" :noDataText="$t('dash.table.no.data')" class="table-content">
      <template slot="thead"> 
        <vs-th class="column pages">
          <p>{{$t('dash.table.title.pages')}}</p>
        </vs-th>
        <vs-th class="column name">
          <p>{{$t('dash.table.title.name')}}</p>
        </vs-th>
        <vs-th class="column topic">
          <p>{{$t('dash.table.title.topic')}}</p>
        </vs-th>
        <vs-th class="column subtopic">
          <p>{{$t('dash.table.title.subtopic')}}</p>
        </vs-th>
        <vs-th class="column source">
          <p>{{$t('dash.table.title.source')}}</p>
        </vs-th>
        <vs-th class="column frequency">
          <p>{{$t('dash.table.title.frequency')}}</p>
        </vs-th>
        <vs-th class="column status">
          <p>{{$t('dash.table.title.status')}}</p>
        </vs-th>
        <vs-th class="column actions">
          <p>{{$t('dash.table.title.actions')}}</p>
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr 
          v-for="(row, index) in data"
          :key="row.id"
          class="row"
          :class="{ disabled: !checkLock(row.pages.network) || (!isUserPremiumActive && index != 0 && !isUserPartner) }"
        >
          <vs-td :data="row.pages.name" class="column pages">
            <Tooltip
              :text="row.pages.name"
              position="top"
            >
              <page-image-avatar :page="row.pages" :class="{ disabled: !checkLock(row.pages.network) }"/>
              <p class="page-name">{{ row.pages.name }}</p>
            </Tooltip>
          </vs-td>
          <div class='bots-data'>
            <vs-tr
              v-for="bot in row.bots"
              :key="bot.id"
              class="column bots hoverFlat"
              :class="{ disabled: (!isUserPremiumActive && index != 0 && !isUserPartner)}"
              :data-qa="`list-bots-${bot.name}`"
            >
              <vs-td
                class="column"
                v-for="(item, i) in columns[1]"
                :key="i"
                :class="item"
              >
                <p v-if="item === 'topic'">{{ bot.service }}</p>
                <p v-else-if="item === 'subtopic'">
                  {{ bot.category ? bot.category.name : '' }}
                </p>
                <p v-else-if="item === 'source'">{{ (bot.category && bot.category.id) || (bot.flux && bot.flux.length) ? bot.domain : $t('dash.bot.sources.none') }}</p>
                <p v-else-if="item === 'frequency'">
                  <span v-if="bot.instant">Instant</span>
                  <span v-else-if="bot.frequency === 0">{{$t('dash.bots.post_frequency_manual')}}</span>
                  <span v-else>{{ bot.frequency }} min</span>
                </p>
                <p v-else-if="item === 'name'">{{ bot.name }}</p>
                <p v-else-if="item === 'status'">
                  <template v-if="(bot.status == 0 && !checkLock('source_choice')) || (!isUserPremiumActive && index != 0 && !isUserPartner)">
                    <Tooltip :text="$t('dash.plan.change_to_get_features')" position="top">
                      <vs-avatar
                        color="transparent"
                        size="18px"
                        :src="require('../../assets/img/icon_stop.svg')"
                        @click="goToPlan()"
                      />
                      <span>&nbsp;</span>
                    </Tooltip>
                  </template>
                  <template v-else-if="bot.page.network === 'facebook' && bot.page.isGroup && row.pages.story_config && row.pages.story_config.onlyConciergerie && !row.pages.story_config.created">
                    <Tooltip
                      :text="$t('dash.bots.status_proxy')"
                      position="top"
                    >
                      <vs-avatar
                        color="transparent"
                        size="18px"
                        :src="
                          require('../../assets/img/icon_wait_proxy.svg')
                        "
                      />
                      <span>&nbsp;</span>
                    </Tooltip>
                  </template>
                  <template v-else-if="!!bot.status && row.pages.instagram_username && (!row.pages.story_config || !row.pages.story_config.created)">
                    <Tooltip
                      :text="$t('dash.bots.status_proxy')"
                      position="top"
                    >
                      <vs-avatar
                        color="transparent"
                        size="18px"
                        :src="
                          require('../../assets/img/icon_wait_proxy.svg')
                        "
                      />
                      <span>&nbsp;</span>
                    </Tooltip>
                  </template>
                  <template v-else-if="!!bot.status && bot.status == 1">
                    <Tooltip
                      :text="$t('dash.bots.status_running') + (bot.page.network == 'linkedin' ? ` - ${$t('dash.bots.next_refresh')} ${dateFromNow(bot.expires_at)}` : '')"
                      position="top"
                    >
                      <vs-avatar
                        color="transparent"
                        size="18px"
                        :src="
                          require('../../assets/img/icon_check_light.svg')
                        "
                      />
                      <span>&nbsp;</span>
                    </Tooltip>
                  </template>
                  <template v-else-if="!!bot.status && bot.status == 2">
                    <Tooltip :text="$t('dash.bots.status_near_expiration')+new Date(bot.error_msg).toLocaleDateString()" position="top">
                      <vs-avatar
                        color="transparent"
                        size="18px"
                        :src="require('../../assets/img/icon_warn.svg')"
                        @click="confirmRefresh(row.pages)"
                      />
                      <a
                        href="#"
                        @click="confirmRefresh(row.pages)"
                        v-html="$t('dash.pages.refreshLabel')"
                      ></a>
                    </Tooltip>
                  </template>
                  <template v-else-if="bot.status == 0 && bot.page.network == 'linkedin'">
                    <Tooltip :text="$t('dash.bots.status_expired')" position="top">
                      <vs-avatar
                        color="transparent"
                        size="18px"
                        :src="require('../../assets/img/icon_stop.svg')"
                        @click="confirmRefresh(row.pages)"
                      />
                      <a
                        href="#"
                        @click="confirmRefresh(row.pages)"
                        v-html="$t('dash.pages.refreshLabel')"
                      ></a>
                    </Tooltip>
                  </template>
                  <template v-else-if="bot.status == 3">
                    <Tooltip :text="$t(bot.error_msg)" position="top">
                      <vs-avatar
                        color="transparent"
                        size="18px"
                        :src="require('../../assets/img/icon_stop.svg')"
                        @click="edit(bot.id)"
                      />
                      <span>&nbsp;</span>
                    </Tooltip>
                  </template>
                  <template v-else-if="bot.page.network === 'facebook' && !bot.page.isGroup && row.pages.story_config && row.pages.story_config.onlyConciergerie && !row.pages.story_config.created">
                    <Tooltip
                      :text="$t('dash.bots.status_proxy')"
                      position="top"
                    >
                      <vs-avatar
                        color="transparent"
                        size="18px"
                        :src="
                          require('../../assets/img/icon_wait_proxy.svg')
                        "
                      />
                      <span>&nbsp;</span>
                    </Tooltip>
                  </template>
                  <template v-else-if="checkLock(bot.page.network)">
                    <Tooltip :text="$t(bot.error_msg)" position="top">
                      <vs-avatar
                        color="transparent"
                        size="18px"
                        :src="require('../../assets/img/icon_stop.svg')"
                        @click="confirmRefresh(row.pages)"
                      />
                      <a
                        href="#"
                        @click="confirmRefresh(row.pages)"
                        v-html="$t('dash.pages.refreshLabel')"
                      ></a>
                    </Tooltip>
                  </template>
                  <template v-else>
                    <vs-avatar
                      color="transparent"
                      size="18px"
                      :src="require('../../assets/img/icon_stop.svg')"
                      style="cursor: default;"
                    />
                  </template>
                </p>
              </vs-td>
              <vs-td class="column actions">
                <vs-button
                  class="btn-large"
                  color="#6a1f4c"
                  vs-type="filled"
                  size="large"
                  type="submit"
                  @click="edit(bot.id)"
                >
                  <p>{{ $t('dash.button.edit') }}</p>
                </vs-button>
              </vs-td>
            </vs-tr>
            <vs-tr v-if="!row.bots.length" class="column bots">
              <vs-td class="column actions no-bot">
                <p>{{ $t('dash.bots.nobot') }}</p>
                <vs-button
                  class="btn-large"
                  color="#6a1f4c"
                  vs-type="filled"
                  size="large"
                  @click="create({ page: row.pages.id })"
                >
                  <p>{{ $t('dash.button.create') }}</p>
                </vs-button>
              </vs-td>
            </vs-tr>
          </div>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
 import Pages from '../mixins/Pages'
 import User from '../mixins/User'
 import Auth from '../mixins/Auth'
 import PageImageAvatar from './PageImageAvatar.vue'
 import Tooltip from './tooltip/tooltipInit.vue'
 
 import moment from 'moment'

 export default {
  name: 'component-multipletable',

  components: {
    PageImageAvatar,
    Tooltip
  },
   
   props: {
     gridData: Array,
     columns: Array,
     name: {
       type: String,
       required: true
     }
   },

   computed: {
     data(){
       return this.gridData.slice().sort((a,b) => (a.pages.name > b.pages.name) ? 1 : ((a.pages.name < b.pages.name) ? -1 : 0))
     }
   },
 
   mixins: [Pages, User, Auth],

   beforeMount() {
     const param = new URLSearchParams(location.search)
     if(param.get('refresh-token')){
       let row  = this.gridData.find(r => r.pages.id == param.get('refresh-token'))
       this.confirmRefresh(row.pages)
     }
   },

   methods: {

    dateFromNow(date){
      let temps = moment(date).toNow(true)
      temps = temps.replace('years', 'ans')
      temps = temps.replace('year', 'an')
      temps = temps.replace('months', 'mois')
      temps = temps.replace('month', 'mois')
      temps = temps.replace('hours', 'heures')
      temps = temps.replace('hour', 'heure')
      temps = temps.replace('days', 'jours')
      temps = temps.replace('day', 'jour')
      temps = temps.replace('un ', '1 ')
      temps = temps.replace('a ', '1 ')
      return temps
    },

     /**
      * Create action on click
      * @param {string}
      */
     create(opt = {}) {
       this.$emit('create', { ...opt })
     },
     /**
      * Edit action on click
      * @param {string}
      */
     edit(bot) {
       this.$emit('edit', bot)
     },

     async checkStateTwitter(page) {
        await this.checkTwitterAccount(page.id).then(res => {
          console.log('res', res)
        })
     }
   }
 }
</script>

<style lang="scss">
.column.bots > .disabled {
  filter: grayscale(1) opacity(0.3);
  & li.column.actions {
    visibility: hidden;
  }
}
</style>
